module.exports = __webpack_public_path__ + "fonts/Poppins-100-latin3.9c2fa32.woff2";